import { singleton } from "tsyringe";
import { Config } from "../config";
import { fetchAndThrowHttpErrors, uuidv4 } from "../utils/helpers";
import { container } from 'tsyringe';

import { BehaviorSubject } from 'rxjs';
import { MediaType, Media, MediaOrigin } from '../models/mediaClass';
import { AssetManagementService } from "./asset-management-service";
import { Asset, tagMediaTypeMapping } from "../models/assetClass";

import * as R from 'ramda';
import { ActionType, GroupType } from '../models/actionClass';
import { CmsManagementService } from './cms-management-service';
import { VideoCms } from '../models/cmsVideoClass';

@singleton()
export class MediaService {

  public fgImages$: BehaviorSubject<Media[]> = new BehaviorSubject<Media[]>([]);
  public fgVideos$: BehaviorSubject<Media[]> = new BehaviorSubject<Media[]>([]);

  public backgrounds$: BehaviorSubject<Media[]> = new BehaviorSubject<Media[]>([]);

  private assetsService: AssetManagementService = container.resolve(AssetManagementService);
  private cmsService: CmsManagementService = container.resolve(CmsManagementService);

  private rootUrl = `${Config.DASHBOARD_URL}${process.env.PUBLIC_URL}`;

  constructor() {

    // to be replaced with a server GET to get all predefined images for our channel
    let predefinedImages = [
      // { id: "7c35cb03-6d36-4e58-aa93-1b0d28cb2575", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/Penske.jpeg', name: 'Penske Factory' },
      // { id: "ec9959e5-74f0-4a7a-885b-7c7f86112cc6", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/Team-Penske.jpeg', name: 'Team Penske' },
      // { id: "8ac5551e-d38f-4f00-826d-8a1cb68568c2", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/Pagenaud.jpeg', name: 'Pagenaud' },
      // { id: "3d40a84f-a894-4d73-82f8-a7532f3413fd", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/Pagenaud-Victory.jpeg', name: 'Pagenaud Victory' },
      { id: "414bc8c0-95e9-429d-8fb9-f9129aa9bb88", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/be-right-back.png', name: 'Be Right Back' },
      { id: "414b2378-564f-4223-8f32-f9129aa9bb44", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/sector-pie-chart.png', name: 'Pie Chart' },
      { id: "2f6fa008-a9d6-433b-8435-bd9261f85917", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/thanks.png', name: 'Thanks' },
      { id: "8862d1ed-09ad-44a4-aa3d-70881feeec94", type: MediaType.FG_IMAGE, source: this.rootUrl + '/images/welcome.png', name: 'Welcome' },

    ];

    // Videos
    let predefinedVideos = [
      { id: "0905050b-9527-4312-af69-ca32a633bd28", type: MediaType.FG_VIDEO, source: this.rootUrl + '/backgrounds/breaking-news.jpg', mp4: this.rootUrl + '/videos/breaking-news.mp4', name: 'Breaking News'},
      { id: "1cc70201-10c6-448c-8495-e8c6f5d052b6", type: MediaType.FG_VIDEO, source: this.rootUrl + '/backgrounds/count-down.jpg', mp4: this.rootUrl + '/videos/count-down.mp4', name: 'Count Down'},
      { id: "1cc70201-10c6-448c-8495-e8c6f5d052c6", type: MediaType.FG_VIDEO, source: this.rootUrl + '/backgrounds/live-stream.jpg', mp4: this.rootUrl + '/videos/live-stream.mp4', name: 'Live Stream'},
      { id: "86eaddae-b8f4-4af9-be1a-650a74f4735f", type: MediaType.FG_VIDEO, source: this.rootUrl + '/backgrounds/studio.jpg', mp4: this.rootUrl + '/videos/studio.mp4', name: 'Studio'},
    ];

    let predefinedBackgrounds = [

      // Static Backgrounds

      { id: "4c4f0080-c9ee-4a7e-a493-04bc6f763c7e", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/1.png', mp4: '', name: '1' },
      { id: "32c52b75-bddc-4b69-8dc0-c48ac4d78697", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/2.png', mp4: '', name: '2' },
      { id: "788d88f0-8a5f-440c-92bc-cd9e35955398", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/3.png', mp4: '', name: '3' },
      { id: "ea06ad33-c637-46c1-b681-63666bc79a04", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/4.png', mp4: '', name: '4' },
      { id: "57545b04-795f-4d36-9172-dab9433457ab", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/5.png', mp4: '', name: '5' },
      { id: "53904f1a-918e-4535-b18b-a1a7d0b02823", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/home-interior.png', mp4: '', name: 'Home Interior' },
      { id: "9ec3b31f-35a2-4be2-85b1-239d3db2d888", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/leather-couch.png', mp4: '', name: 'Leather Couch' },
      { id: "272f5f49-a118-46a3-9c93-bbdc5ed9244f", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/rattan-basket.png', mp4: '', name: 'Rattan Basket' },
      { id: "4a8c9826-7260-46b2-8ee1-eb91766d7643", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/yellow-couch.png', mp4: '', name: 'Yellow Couch' },
      { id: "a6224f2b-9022-49da-87d6-bb2af3ef66ec", type: MediaType.BG_IMAGE, source: this.rootUrl + '/backgrounds/living-room.png', mp4: '', name: 'Living Room' },

      // Video Backgrounds

      { id: "dcc097dd-d1ba-45b6-ab0a-9dea75872c89", type: MediaType.BG_VIDEO, source: this.rootUrl + '/backgrounds/bg-futuristic-blue.jpg', mp4: this.rootUrl + '/videos/bg-futuristic-blue.mp4', name: 'Futuristic Blue' },
      { id: "1b02a16c-c92f-43bb-b88b-54f49775215e", type: MediaType.BG_VIDEO, source: this.rootUrl + '/backgrounds/bg-neon-diagonal-blue.jpg', mp4: this.rootUrl + '/videos/bg-neon-diagonal-blue.mp4', name: 'Neon Diagonal Blue' },
      { id: "e4924ba9-b530-46f6-b342-79b2ce774d25", type: MediaType.BG_VIDEO, source: this.rootUrl + '/backgrounds/bg-news-loop.jpg', mp4: this.rootUrl + '/videos/bg-news-loop.mp4', name: 'News Loop' },
      { id: "b0ea7285-ffa7-44a1-815b-5c07e81e2e6f", type: MediaType.BG_VIDEO, source: this.rootUrl + '/backgrounds/bg-retrowave.jpg', mp4: this.rootUrl + '/videos/bg-retrowave.mp4', name: 'Retro Wave' },
      { id: "e41b9e20-c483-427d-b1be-0a840e6300fe", type: MediaType.BG_VIDEO, source: this.rootUrl + '/backgrounds/bg-strip-loop.jpg', mp4: this.rootUrl + '/videos/bg-strip-loop.mp4', name: 'Strip Loop' },
      { id: "08c46857-9311-4e48-87c0-39a66917ccca", type: MediaType.BG_VIDEO, source: this.rootUrl + '/backgrounds/bg-water.jpg', mp4: this.rootUrl + '/videos/bg-water.mp4', name: 'Water' },
    ];


    // const lsFgImages = localSbg-strip-looptorage.getItem('fgImages-v2');
    // if (lsFgImages && lsFgImages !== '[]') {
    //   try {
    //     predefinedImages = JSON.parse(lsFgImages);
    //   } catch (e) { }
    // }
    // const lsFgVideos = localStorage.getItem('fgVideos-v2');
    // if (lsFgVideos && lsFgVideos !== '[]') {
    //   try {
    //     predefinedVideos = JSON.parse(lsFgVideos);
    //   } catch (e) { }
    // }
    // const lsBackgrounds = localStorage.getItem('backgrounds-v2');
    // if (lsBackgrounds && lsBackgrounds !== '[]') {
    //   try {
    //     predefinedBackgrounds = JSON.parse(lsBackgrounds);
    //   } catch (e) { }
    // }


    const images = [];
    for (const i of predefinedImages) {
      const media = new Media(i.id, i.source, i.name, null, i.type, MediaOrigin.PREDEFINED);
      images.push(media);
    }
    this.fgImages$.next(images);

    const videos = [];
    for (const v of predefinedVideos) {
      const media = new Media(v.id, v.source, v.name, v.mp4, v.type, MediaOrigin.PREDEFINED);
      videos.push(media);
    }
    this.fgVideos$.next(videos);

    const backgrounds = [];
    for (const bg of predefinedBackgrounds) {
      const media = new Media(bg.id, bg.source, bg.name, bg.mp4, bg.type, MediaOrigin.PREDEFINED);
      if (media.id === 'ea06ad33-c637-46c1-b681-63666bc79a04') {
        media.selected = true;
      }
      backgrounds.push(media);
    }
    // get user's background from assets
    this.backgrounds$.next(backgrounds);

    this.getUserAssets();
    this.getUserVideos();

  }

  processVideos(origin: MediaOrigin, videos: VideoCms[], type: MediaType, categoryCollection) {

    const assetLastUploadDate = parseInt(localStorage.getItem('assetLastUploadDate') || Number.MAX_SAFE_INTEGER.toString());

    let mediasInCategory = categoryCollection.getValue().filter(m => m.origin === MediaOrigin.PREDEFINED);

    if (videos && videos.length && videos.length > 0) {
      const medias = [];
      for (const v of videos) {
        let media = null;

        // console.log('video to media', v);

        media = new Media(v.id.toString(), v.contentProperties?.thumbnail, v.contentName, v.contentUrl, MediaType.FG_VIDEO, origin);

        media.isNew = (v.modified > assetLastUploadDate);
        medias.push(media);
      }
      // add users assets before predefined
      categoryCollection.next([...medias, ...mediasInCategory]);
    }


  }


  processAssets(origin: MediaOrigin, assets: Asset[], type: MediaType, categoryCollection) {

    const assetLastUploadDate = parseInt(localStorage.getItem('assetLastUploadDate') || Number.MAX_SAFE_INTEGER.toString());

    let mediasInCategory = categoryCollection.getValue().filter(m => m.origin === MediaOrigin.PREDEFINED);
    console.log("will load assets into medias ", type, assets)
    if (assets && assets.length && assets.length > 0) {
      const medias = [];
      for (const a of assets) {
        let media = null;
        const assetType = tagMediaTypeMapping[a.tag] || MediaType.BG_IMAGE;

        // check asset type is the one we looking for
        if (assetType === type ||
          assetType === MediaType.BG_IMAGE && type === MediaType.BACKGROUND ||
          assetType === MediaType.BG_VIDEO && type === MediaType.BACKGROUND) {

          if (assetType === MediaType.BG_IMAGE || type === MediaType.FG_IMAGE || type === MediaType.LOGO) {
            media = new Media(a.id, a.assetUrl, a.title, null, assetType, origin);
          } else {
            media = new Media(a.id, a.assetThumbnailUrl, a.title, a.assetUrl, assetType, origin);
          }

          // const oldMedia = mediasInCategory.find(m => m.id === a.id);
          // if (oldMedia) {
          //   // update
          //   oldMedia.name = media.name;
          //   oldMedia.source = media.source;
          //   oldMedia.mp4 = media.mp4;
          // } else {
          media.isNew = (a.createdDate > assetLastUploadDate);
          medias.push(media);
          // }

        }
      }
      // add users assets before predefined
      categoryCollection.next([...medias, ...mediasInCategory]);
    }
  }

  getUserAssets = () => {
    // get last uploaded asset
    this.assetsService.assetList$.subscribe((assets: Asset[]) => {

      this.processAssets(MediaOrigin.USER_ASSET, assets, MediaType.BACKGROUND, this.backgrounds$);
      this.processAssets(MediaOrigin.USER_ASSET, assets, MediaType.FG_IMAGE, this.fgImages$);
      // this.processAssets(MediaOrigin.USER_ASSET, assets, MediaType.FG_VIDEO, this.fgVideos$);
    })

    // get organizer's asset
    this.assetsService.assetListOrg$.subscribe((assets: Asset[]) => {
      this.processAssets(MediaOrigin.MEETING_ASSET, assets, MediaType.BACKGROUND, this.backgrounds$);;
      this.processAssets(MediaOrigin.MEETING_ASSET, assets, MediaType.FG_IMAGE, this.fgImages$);
      // this.processAssets(MediaOrigin.MEETING_ASSET, assets, MediaType.FG_VIDEO, this.fgVideos$);
    })

  }

  getUserVideos = () => {
    this.cmsService.videoList$.subscribe((videos) => {
      this.processVideos(MediaOrigin.USER_ASSET, videos, MediaType.FG_VIDEO, this.fgVideos$);
    })
  }


  refresh(type: MediaType) {
    // if (type === MediaType.BACKGROUND) {
    //   this.getUserAssets(MediaType.BACKGROUND, this.backgrounds$);
    // } else if (type === MediaType.FG_IMAGE) {
    //   this.getUserAssets(MediaType.FG_IMAGE, this.fgImages$);
    // } else if (type === MediaType.FG_VIDEO) {
    //   this.getUserAssets(MediaType.FG_VIDEO, this.fgVideos$);
    // }
  }

  addDefault(media: Media, type: MediaType, origin: MediaOrigin) {

    if (!media) {
      media = new Media(uuidv4(), '', '', '', type, origin);
    }

    if (type === MediaType.FG_IMAGE) {
      const fgimages = R.clone(this.fgImages$.getValue()); // clone to force update
      fgimages.unshift(media);
      this.fgImages$.next(fgimages);
      return media;

    } else if (type === MediaType.FG_VIDEO) {
      const fgvideos = R.clone(this.fgVideos$.getValue()); // clone to force update
      fgvideos.unshift(media);
      this.fgImages$.next(fgvideos);
      return media;

    } else if (type === MediaType.BG_VIDEO || type === MediaType.BG_IMAGE) {
      const backgrounds = R.clone(this.backgrounds$.getValue()); // clone to force update
      backgrounds.unshift(media);
      this.fgImages$.next(backgrounds);
      return media;
    }
    return null;
  }

  select(type: MediaType, sourceId: string) {

    if (type === MediaType.FG_IMAGE) {
      const images = R.clone(this.fgImages$.getValue());
      const media = images.find(m => m.id === sourceId);

      if (media) {
        // select this media
        media.selected = true;
        media.isNew = false;

        // and update subject
        this.fgImages$.next(images);
        return media;
      }
      return null;
    } else if (type === MediaType.FG_VIDEO) {

      const videos = R.clone(this.fgVideos$.getValue());
      const media = videos.find(m => m.id === sourceId);

      if (media) {
        // select this media
        media.selected = true;
        media.isNew = false;

        // and update subject
        this.fgVideos$.next(videos);
        return media;
      }
      return null;
    } else if (type === MediaType.BG_IMAGE || type === MediaType.BG_VIDEO) {

      const backgrounds = R.clone(this.backgrounds$.getValue());
      const media = backgrounds.find(m => m.id === sourceId);

      if (media) {
        // select this media
        media.selected = true;
        media.isNew = false;

        // and update subject
        this.backgrounds$.next(backgrounds);
        return media;
      }
      return null;
    }
  }

  unselect(type: MediaType, sourceId: string) {
    if (type === MediaType.FG_VIDEO) {

      const videos = R.clone(this.fgVideos$.getValue());
      if (sourceId) {
        const media = videos.find(i => i.id === sourceId);
        if (media) {
          media.selected = false;
          media.isNew = false;
        }
      } else {
        videos.forEach(m => m.selected = false);
      }
      this.fgVideos$.next(videos);

    } else if (type === MediaType.FG_IMAGE) {

      const images = R.clone(this.fgImages$.getValue());
      if (sourceId) {
        const media = images.find(i => i.id === sourceId);
        if (media) {
          media.selected = false;
          media.isNew = false;
        }
      } else {
        images.forEach(m => m.selected = false);
      }
      this.fgImages$.next(images);

    } else if (type === MediaType.BG_IMAGE || type === MediaType.BG_VIDEO) {

      const backgrounds = R.clone(this.backgrounds$.getValue());
      if (sourceId) {
        const media = backgrounds.find(i => i.id === sourceId);
        if (media) {
          media.selected = false;
          media.isNew = false;
        }
      } else {
        backgrounds.forEach(m => m.selected = false);
      }
      this.backgrounds$.next(backgrounds);
    }
  }

  async remove(type: MediaType, mediaId: string, origin: MediaOrigin) {

    if (type === MediaType.FG_IMAGE) {
      const fgImages = R.clone(this.fgImages$.getValue().filter(fgi => fgi.id !== mediaId));
      this.fgImages$.next(fgImages);
      const ffgImages = fgImages.filter(i => i.origin === MediaOrigin.PREDEFINED);
      if (ffgImages.length > 0) {
        localStorage.setItem('fgImages-v2', JSON.stringify(ffgImages));
      } else {
        localStorage.removeItem('fgImages-v2');
      }

    } else if (type === MediaType.FG_VIDEO) {

      const fgVideos = R.clone(this.fgVideos$.getValue().filter(fgv => fgv.id !== mediaId));
      this.fgVideos$.next(fgVideos);
      const ffgVideos = fgVideos.filter(i => i.origin === MediaOrigin.PREDEFINED);
      if (ffgVideos.length > 0) {
        localStorage.setItem('fgVideos-v2', JSON.stringify(ffgVideos));
      } else {
        localStorage.removeItem('fgVideos-v2');
      }

    } else if (type === MediaType.BG_IMAGE || type === MediaType.BG_VIDEO) {

      const backgrounds = R.clone(this.backgrounds$.getValue().filter(bg => bg.id !== mediaId));
      this.backgrounds$.next(backgrounds);

      // filter assets
      const fbackgrounds = backgrounds.filter(i => i.origin === MediaOrigin.PREDEFINED)
      if (fbackgrounds.length > 0) {
        localStorage.setItem('backgrounds-v2', JSON.stringify(fbackgrounds));
      } else {
        localStorage.removeItem('backgrounds-v2');
      }
    }

    if (origin === MediaOrigin.USER_ASSET) {
      if (type !== MediaType.FG_VIDEO) {
        // is media a user asset ?
        await this.assetsService.deleteAsset(mediaId);
        // setTimeout(() => {
          //   this.assetsService.loadAssets();
          // }, 5000);
      } else {
        await this.cmsService.deleteVideo(mediaId);
      }
    }
  }

  save(type, media) {
    let isRenamed = false;
    if (type === MediaType.FG_IMAGE) {

      const fgImages = R.clone(this.fgImages$.getValue());
      const fgi = fgImages.find(m => m.id === media.id);
      if (fgi) {
        isRenamed = (media.name !== fgi.name);
        fgi.isNew = media.isNew;
        fgi.isAdding = false;
        fgi.source = R.clone(media.source);
        fgi.mp4 = R.clone(media.mp4);
        fgi.name = R.clone(media.name);
        this.fgImages$.next(fgImages);
        const ffgImages = fgImages.filter(i => i.origin === MediaOrigin.PREDEFINED);
        if (ffgImages.length > 0) {
          localStorage.setItem('fgImages-v2', JSON.stringify(ffgImages));
        } else {
          localStorage.removeItem('fgImages-v2');
        }
      }

    } else if (type === MediaType.FG_VIDEO) {

      const fgVideos = R.clone(this.fgVideos$.getValue());
      const fgv = fgVideos.find(m => m.id === media.id);
      if (fgv) {
        isRenamed = (media.name !== fgv.name);
        fgv.isNew = media.isNew;
        fgv.isAdding = false;
        fgv.source = R.clone(media.source);
        fgv.mp4 = R.clone(media.mp4);
        fgv.name = R.clone(media.name);
        this.fgVideos$.next(fgVideos);
        const ffgVideos = fgVideos.filter(i => i.origin === MediaOrigin.PREDEFINED);
        if (ffgVideos.length > 0) {
          localStorage.setItem('fgVideos-v2', JSON.stringify(ffgVideos));
        } else {
          localStorage.removeItem('fgVideos-v2');
        }
      }
    } else if (type === MediaType.BG_IMAGE || type === MediaType.BG_VIDEO) {
      let backgrounds = R.clone(this.backgrounds$.getValue());
      const bg = backgrounds.find(m => m.id === media.id);
      if (bg) {
        isRenamed = (media.name !== bg.name);
        bg.isNew = media.isNew;
        bg.isAdding = false;
        bg.source = R.clone(media.source);
        bg.mp4 = R.clone(media.mp4);
        bg.name = R.clone(media.name);
        this.backgrounds$.next(backgrounds);

        // filter assets
        const fbackgrounds = backgrounds.filter(i => i.origin === MediaOrigin.PREDEFINED)
        if (fbackgrounds.length > 0) {
          localStorage.setItem('backgrounds-v2', JSON.stringify(fbackgrounds));
        } else {
          localStorage.removeItem('backgrounds-v2');
        }
      }
    }


    if (isRenamed && media.origin === MediaOrigin.USER_ASSET) {
      // update name in assets
      this.assetsService.renameAsset(media.id, media.name);
    }

  }


  processUpdate(reason) {
    if (reason.group !== GroupType.BG_IMAGE &&
      reason.group !== GroupType.BG_VIDEO &&
      reason.group !== GroupType.FG_IMAGE &&
      reason.group !== GroupType.FG_VIDEO) return;

    if (reason.action === ActionType.REMOVE) {
      // find id in background and remove
      this.unselect(reason.group, reason.id);
      this.remove(reason.group, reason.id, MediaOrigin.MEETING_ASSET);
    }

    if ((reason.group === GroupType.BG_IMAGE || reason.group === GroupType.BG_VIDEO)) {
      const backgrounds = R.clone(this.backgrounds$.getValue());
      if (reason.action === ActionType.ADD) {
        const bg = this.addDefault(null, reason.group, MediaOrigin.MEETING_ASSET);
        bg.id = reason.id;
        bg.isNew = true;
        bg.source = reason.source;
        bg.mp4 = reason.mp4;
        bg.name = reason.name;
        backgrounds.push(bg)
      } else if (reason.action === ActionType.RENAME) {
        const bg = backgrounds.find(m => m.id === reason.value.id);
        if (bg) {
          bg.name = reason.value.name;
          bg.isNew = true;
        }
      }
      this.backgrounds$.next(backgrounds);

      // filter assets
      const fbackgrounds = backgrounds.filter(i => i.origin === MediaOrigin.PREDEFINED)
      if (fbackgrounds.length > 0) {
        localStorage.setItem('backgrounds-v2', JSON.stringify(fbackgrounds));
      } else {
        localStorage.removeItem('backgrounds-v2');
      }

    }
    else if (reason.group === GroupType.FG_IMAGE) {
      const images = R.clone(this.fgImages$.getValue());
      if (reason.action === ActionType.ADD) {
        const fgi = this.addDefault(null, reason.group, MediaOrigin.MEETING_ASSET);
        fgi.id = reason.id;
        fgi.isNew = true;
        fgi.source = reason.source;
        fgi.mp4 = reason.mp4;
        fgi.name = reason.name;
        images.push(fgi)
      } else if (reason.action === ActionType.RENAME) {
        const fgi = images.find(m => m.id === reason.value.id);
        if (fgi) {
          fgi.name = reason.value.name;
          fgi.isNew = true;
        }
      }
      this.fgImages$.next(images);
      const ffgImages = images.filter(i => i.origin === MediaOrigin.PREDEFINED);
      if (ffgImages.length > 0) {
        localStorage.setItem('fgImages-v2', JSON.stringify(ffgImages));
      } else {
        localStorage.removeItem('fgImages-v2');
      }
    }
    else if (reason.group === GroupType.FG_VIDEO) {
      const videos = R.clone(this.fgVideos$.getValue());
      if (reason.action === ActionType.ADD) {
        const fgv = this.addDefault(null, reason.group, MediaOrigin.MEETING_ASSET);
        fgv.id = reason.id;
        fgv.isNew = true;
        fgv.source = reason.source;
        fgv.mp4 = reason.mp4;
        fgv.name = reason.name;
        videos.push(fgv)
      } else if (reason.action === ActionType.RENAME) {
        const fgv = videos.find(m => m.id === reason.value.id);
        if (fgv) {
          fgv.name = reason.value.name;
          fgv.isNew = true;
        }
      }
      this.fgVideos$.next(videos);
      const ffgVideos = videos.filter(i => i.origin === MediaOrigin.PREDEFINED);
      if (ffgVideos.length > 0) {
        localStorage.setItem('fgVideos-v2', JSON.stringify(ffgVideos));
      } else {
        localStorage.removeItem('fgVideos-v2');
      }

    }


  }

}
